import Vue from "vue";
import Router from "vue-router";
// import Home from "./views/Home.vue";
import Home from "./views/contents/Login.vue";
const user = JSON.parse(localStorage.getItem("user"));

Vue.use(Router);

function dashboardGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = [
    "Administrator",
    "Call Centre",
    "Charity",
    "Claim",
    "Finance",
    "General",
    "TBA Staff",
    "TBK Staff",
    "Marketing"
  ];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }
  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function changeFormGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = [
    "Administrator",
    "Call Centre",
    "Charity",
    "Claim",
    "Finance",
    "General",
    "TBA Staff",
    "TBK Staff"
  ];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }
  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function notificationGuard(to, from, next) {
  let isAllowed = false;
  let disallowedList = ["Administrator", "Finance"];
  let allowedList = [
    "Call Centre",
    "Charity",
    "Claim",
    "General",
    "TBA Staff",
    "TBK Staff",
    "Vendor",
    "Marketing"
  ];

  user.roles.forEach(element => {
    if (disallowedList.includes(element.name)) {
      isAllowed = false;
    }
  });

  if (!isAllowed) {
    user.roles.forEach(element => {
      if (allowedList.includes(element.name)) {
        isAllowed = true;
      }
    });
  }

  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function tbaGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["Administrator", "TBA Staff"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }

  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function tbkGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["Administrator", "TBK Staff"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }

  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function marketingGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["Marketing"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }
  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function marketingTBAStaffGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["TBA Staff", "Marketing"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }
  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function demographicGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["Administrator", "TBA Staff", "TBK Staff"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }

  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function reportTBKGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["Administrator", "TBK Staff", "Finance"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }

  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function reportTBAGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["Administrator", "TBA Staff", "Finance"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }

  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

function vendorGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["Vendor", "Marketing", "Administrator"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }

  if (isAllowed) {
    next();
  } else {
    next("/banner");
  }
}

function settingGuard(to, from, next) {
  let isAllowed = false;
  let allowedList = ["Administrator", "Marketing"];

  for (let i = 0; i < user.roles.length; i++) {
    if (allowedList.includes(user.roles[i].name)) {
      isAllowed = true;
      break;
    } else {
      isAllowed = false;
    }
  }

  if (isAllowed) {
    next();
  } else {
    next("/dashboard");
  }
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Home
    {
      path: "/",
      name: "home",
      component: Home
    },

    // Page 404
    {
      path: "*",
      name: "404",
      component: () => import("./views/404.vue")
    },

    // About
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },

    // Dashboard
    {
      path: "/dashboard",
      name: "dashboard",
      beforeEnter: dashboardGuard,
      component: () => import("./views/contents/Dashboard.vue")
    },

    // Notifications
    {
      path: "/notifications",
      name: "notifications",
      component: () => import("./views/contents/Notifications.vue"),
      beforeEnter: notificationGuard
    },

    // TBA Call Request
    {
      path: "/tba_call_request",
      name: "tba_call_request",
      component: () => import("./views/contents/TBA_call_request.vue"),
      beforeEnter: tbaGuard
    },
    {
      path: "/tba_call_request/detail/:id",
      name: "tba_call_details",
      component: () => import("./views/contents/TBA_call_detail.vue"),
      beforeEnter: tbaGuard
    },

    // TBK Call Request
    {
      path: "/tbk_call_request",
      name: "tbk_call_request",
      component: () => import("./views/contents/TBK_call_request.vue"),
      beforeEnter: tbkGuard
    },
    {
      path: "/tbk_call_request/detail/:id",
      name: "tbk_call_details",
      component: () => import("./views/contents/TBK_call_detail.vue"),
      beforeEnter: tbaGuard
    },

    // TBA Purchase
    {
      path: "/tba_purchase",
      name: "tba_purchase",
      component: () => import("./views/contents/TBA_purchase.vue"),
      beforeEnter: tbaGuard
    },

    // Motor Purchases
    {
      path: "/motor_purchases",
      name: "motor_purchases",
      component: () => import("./views/contents/TBA/MotorPurchases.vue"),
      beforeEnter: tbaGuard
    },

    // TBA Purchase Details
    {
      path: "/tba/details/:id",
      name: "tba_details",
      component: () => import("./views/contents/TBA_details.vue"),
      beforeEnter: tbaGuard
    },

    // TBA Renewal
    {
      path: "/tba_renewal",
      name: "tba_renewal",
      component: () => import("./views/contents/TBA_renewal.vue"),
      beforeEnter: tbaGuard
    },

    // TBA Claim
    {
      path: "/tba_claim",
      name: "tba_claim",
      component: () => import("./views/contents/TBA_claim.vue"),
      beforeEnter: tbaGuard
    },

    // TBA Claim Details
    {
      path: "/tba/claim_details/:id",
      name: "tba_claim_details",
      component: () => import("./views/contents/TBA_claim_details.vue"),
      beforeEnter: tbaGuard
    },
    {
      path: "/tba/feedback",
      name: "tba_feedback",
      component: () => import("./views/contents/TBA_feedback.vue"),
      beforeEnter: tbaGuard
    },

    {
      path: "/tba/approved-claims",
      name: "approved-claims",
      component: () => import("./views/contents/approved-claims/index.vue"),
      beforeEnter: tbaGuard
    },
    {
      path: "/tba/terms-and-conditions",
      name: "terms-and-conditions",
      component: () => import("./views/contents/tba-terms/index.vue"),
      beforeEnter: tbaGuard
    },
    {
      path: "/tba/contacts",
      name: "contacts",
      component: () => import("./views/contents/tba-contacts/index.vue"),
      beforeEnter: tbaGuard
    },

    // TBA SPD records
    {
      path: "/tba/spd_records",
      name: "tba_speed_records",
      component: () => import("./views/contents/TBA/SpdRecords.vue")
    },

    // TBA SPD record
    {
      path: "/tba/spd_records/:sysId/:type",
      name: "tba_speed_record",
      component: () => import("./views/contents/TBA/SpdRecord.vue")
    },

    // TBA SPD record history
    {
      path: "/tba/spd_records_history/",
      name: "tba_speed_record_history",
      component: () => import("./views/contents/TBA/SpdRecordsHistory.vue")
    },

    // TBK Claim Details
    {
      path: "/tbk/claim_details/:id",
      name: "tbk_claim_details",
      component: () => import("./views/contents/TBK_claim_details.vue"),
      beforeEnter: tbkGuard
    },

    // TBK Purchase
    {
      path: "/tbk_purchase",
      name: "tbk_purchase",
      component: () => import("./views/contents/TBK_purchase.vue"),
      beforeEnter: tbkGuard
    },

    // TBK Renewal
    {
      path: "/tbk_renewal",
      name: "tbk_renewal",
      component: () => import("./views/contents/TBK_renewal.vue"),
      beforeEnter: tbkGuard
    },

    // TBK Claim
    {
      path: "/tbk_claim",
      name: "tbk_claim",
      component: () => import("./views/contents/TBK_claim.vue"),
      beforeEnter: tbkGuard
    },

    // Marketing
    {
      path: "/marketing",
      name: "marketing",
      component: () => import("./views/contents/Marketing.vue"),
      beforeEnter: marketingTBAStaffGuard
    },

    // total registration
    {
      path: "/marketing/total-registration",
      name: "total_registration",
      component: () => import("./views/contents/reports/TotalRegistration.vue"),
      beforeEnter: marketingGuard
    },

    // Home banner
    {
      path: "/banners",
      name: "banners",
      component: () => import("./views/contents/Banners.vue"),
      beforeEnter: marketingGuard
    },

    // Home banner
    {
      path: "/banners/detail/:id",
      name: "banner_detail",
      component: () => import("./views/contents/Banners_detail.vue"),
      beforeEnter: marketingGuard
    },

    // New banner
    {
      path: "/banners/new",
      name: "banner_new",
      component: () => import("./views/contents/Banners_new.vue"),
      beforeEnter: marketingGuard
    },

    //Promotion
    {
      path: "/promotion",
      name: "promotion-main-page",
      component: () => import("./views/contents/Promotion.vue"),
      beforeEnter: marketingGuard
    },

    // Promotion New
    {
      path: "/marketing/promotion/new",
      name: "promotion_new",
      component: () => import("./views/contents/Promotion_new.vue"),
      beforeEnter: marketingGuard
    },

    // Advert New and Update
    {
      path: "/marketing/advert/new",
      name: "advert_new",
      component: () => import("./views/contents/advert/add.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/marketing/advert/update/:id",
      name: "advert_edit",
      component: () => import("./views/contents/advert/main-edit.vue"),
      beforeEnter: marketingGuard
    },

    // Promotion Update
    {
      path: "/promotion/update/:id",
      name: "promotion_update",
      component: () => import("./views/contents/Promotion_update.vue"),
      beforeEnter: marketingGuard
    },

    //Payment Promotion
    {
      path: "/marketing/payment_promotion",
      name: "payment_promotion",
      component: () =>
        import("./views/contents/promotion/Payment_promotion.vue"),
      beforeEnter: marketingGuard
    },

    // Marketing Product Details
    {
      path: "/marketing/product/detail/:id",
      name: "product_detail",
      component: () =>
        import("./views/contents/advanced-promo/product-details-index.vue"),
      beforeEnter: marketingTBAStaffGuard
    },

    //Authorised Workshop
    {
      path: "/marketing/workshop",
      name: "workshop",
      component: () =>
        import("./views/contents/workshop/Authorised_workshop.vue"),
      beforeEnter: marketingGuard
    },

    // Report
    {
      path: "/report",
      name: "report",
      component: () => import("./views/contents/Report.vue")
    },

    // Finance Report
    {
      path: "/finance_report",
      name: "finance_report",
      component: () => import("./views/contents/Finance_report.vue")
    },

    // Report Demographic
    {
      path: "/demographic",
      name: "report-demographic",
      component: () => import("./views/contents/reports/Demographic.vue"),
      beforeEnter: demographicGuard
    },

    // Report Musafir Orders
    {
      path: "/report/musafir/order",
      name: "report/musafir/order",
      component: () => import("./views/contents/reports/Musafir_orders.vue")
    },

    // Customer
    {
      path: "/report-customers",
      name: "report-customers",
      component: () => import("./views/contents/reports/Customer.vue")
    },

    // Transaction
    {
      path: "/report-transactions-tba/:tbType",
      name: "report-transactions-tba",
      component: () => import("./views/contents/reports/Transaction.vue"),
      beforeEnter: reportTBAGuard
    },

    {
      path: "/report-transactions-tbk/:tbType",
      name: "report-transactions-tbk",
      component: () => import("./views/contents/reports/TransactionTBK.vue"),
      beforeEnter: reportTBKGuard
    },

    // Products
    {
      path: "/report-products",
      name: "report-products",
      component: () => import("./views/contents/reports/Product.vue")
    },

    // Claims
    {
      path: "/report-claims",
      name: "report-claims",
      component: () => import("./views/contents/reports/Claim.vue")
    },

    // Chat
    // {
    //   path: "/live-chat",
    //   name: "live-chat",
    //   component: () =>
    //     import("./views/contents/Live-Chat.vue")
    // },

    // Log
    {
      path: "/log",
      name: "log",
      component: () => import("./views/contents/Log.vue")
    },
    // Chat
    // {
    //   path: "/live-chat",
    //   name: "live-chat",
    //   component: () => import("./views/contents/Live-Chat.vue")
    // },

    //Error List
    {
      path: "/tba-error",
      name: "tba-error",
      component: () => import("./views/contents/Error_tba.vue")
    },

    {
      path: "/tbk-error",
      name: "tbk-error",
      component: () => import("./views/contents/Error_tbk.vue")
    },

    // Account
    {
      path: "/account",
      name: "account",
      component: () => import("./views/contents/Account.vue")
    },

    // Users Management
    {
      path: "/manage-users",
      name: "manage-users",
      component: () => import("./views/contents/ManageUsers.vue")
    },

    //Add Staff
    {
      path: "/add_staff",
      name: "add_staff",
      component: () => import("./views/contents/add_staff.vue")
    },

    // Edit Staff
    {
      path: "/edit_staff/:id",
      name: "edit_staff",
      component: () => import("./views/contents/Edit_staff.vue")
    },

    // Customers
    {
      path: "/customers",
      name: "customers",
      component: () => import("./views/contents/customers/Customers.vue"),
      beforeEnter: dashboardGuard
    },

    // Otps
    {
      path: "/otps",
      name: "otps",
      component: () => import("./views/contents/reports/Otps.vue")
    },

    // Customer Details
    {
      path: "/customer/:ic_number",
      name: "customer_details",
      component: () =>
        import("./views/contents/customers/Customer_details.vue"),
      beforeEnter: dashboardGuard
    },

    // Register
    {
      path: "/register",
      name: "register",
      component: () => import("./views/contents/Register.vue")
    },
    // Threshold
    {
      path: "/treshold",
      name: "treshold",
      component: () => import("./views/contents/Treshold.vue"),
      beforeEnter: tbaGuard
    },

    // Login
    {
      path: "/login",
      name: "login",
      component: () => import("./views/contents/Login.vue")
    },

    // Forgot Password
    {
      path: "/forgot_password",
      name: "forgot_password",
      component: () => import("./views/contents/Forgot_password.vue")
    },

    // Privacy Policy
    {
      path: "/privacy_policy",
      name: "privacy_policy",
      component: () => import("./views/PrivacyPolicy.vue")
    },

    // User Agreement
    {
      path: "/user_agreement",
      name: "user_agreement",
      component: () => import("./views/UserAgreement.vue")
    },

    //Delete User
    {
      path: "/delete-users",
      name: "delete-users",
      component: () => import("./views/contents/admin/Delete_user.vue")
    },

    // Change Form
    {
      path: "/change-forms",
      name: "change-forms",
      component: () => import("./views/contents/changeform/Table.vue"),
      beforeEnter: changeFormGuard
    },
    {
      path: "/change-form-request",
      name: "change-form-equest",
      component: () => import("./views/contents/changeform/Request.vue"),
      beforeEnter: changeFormGuard
    },

    // Live chat
    {
      path: "/live-chat/:tb_type",
      name: "live-chat",
      component: () => import("./views/contents/Live-Chat.vue")
    },

    /**
     * TBM POINTS
     */

    /**
     * ROLE ADMIN / MARKETING
     */

    //  FAQ
    {
      path: "/faq",
      name: "faq-view",
      component: () => import("./views/contents/loyalty/Admin/Faq/View.vue"),
      beforeEnter: marketingGuard
    },
    {
      path: "/faq/update/:id",
      name: "faq-update",
      component: () => import("./views/contents/loyalty/Admin/Faq/Update.vue"),
      beforeEnter: marketingGuard
    },
    {
      path: "/faq/new",
      name: "faq-new",
      component: () => import("./views/contents/loyalty/Admin/Faq/Create.vue"),
      beforeEnter: marketingGuard
    },

    // Account
    {
      path: "/lps/account/vendor",
      name: "account-view",
      component: () =>
        import("./views/contents/loyalty/Admin/Account/View.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/account/add",
      name: "account-add",
      props: { edit: false },
      component: () => import("./views/contents/loyalty/Admin/Account/Add.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/account/edit/:id",
      name: "account-edit",
      props: { edit: true },
      component: () => import("./views/contents/loyalty/Admin/Account/Add.vue"),
      beforeEnter: marketingGuard
    },

    // Vendor
    {
      path: "/lps/vendor/view",
      name: "vendor-view",
      component: () => import("./views/contents/loyalty/Admin/Vendor/View.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/vendor/company/:id",
      name: "company-request-update",
      component: () =>
        import("./views/contents/loyalty/Admin/Vendor/Company_request.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/vendor/company/details/:id",
      name: "company-request-details",
      component: () =>
        import(
          "./views/contents/loyalty/Admin/Vendor/Company_request_details.vue"
        ),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/vendor/product/:id",
      name: "product-request-update",
      component: () =>
        import("./views/contents/loyalty/Admin/Vendor/Product_request.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/vendor/product/details/:vendor_id/:id",
      name: "product-request-details",
      component: () =>
        import(
          "./views/contents/loyalty/Admin/Vendor/Product_request_details.vue"
        ),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/vendor/redeem-list/:id",
      name: "vendor-redeem-list",
      component: () =>
        import("./views/contents/loyalty/Admin/Vendor/Redeem_list.vue"),
      beforeEnter: marketingGuard
    },

    // Survey
    {
      path: "/marketing/survey",
      name: "survey-view",
      component: () => import("./views/contents/loyalty/Admin/Survey/View.vue"),
      beforeEnter: marketingGuard
    },
    // Add
    {
      path: "/marketing/survey/add",
      name: "survey-add",
      props: { edit: false },
      component: () => import("./views/contents/loyalty/Admin/Survey/Add.vue"),
      beforeEnter: marketingGuard
    },
    // Edit
    {
      path: "/marketing/survey/edit/:id",
      name: "survey-edit",
      props: { edit: true },
      component: () => import("./views/contents/loyalty/Admin/Survey/Add.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/marketing/survey/view/",
      name: "survey-view-answer",
      component: () =>
        import("./views/contents/loyalty/Admin/Survey/ListUserSurvey.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/marketing/survey/view/answer/:id",
      name: "view-answer",
      component: () =>
        import("./views/contents/loyalty/Admin/Survey/ViewAnswer.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/marketing/survey/user/answer/:id/:user_id",
      name: "view-user-answer",
      component: () =>
        import("./views/contents/loyalty/Admin/Survey/UserAnswer.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/marketing/survey/report/:id",
      name: "survey-report",
      component: () =>
        import("./views/contents/loyalty/Admin/Survey/Report.vue"),
      beforeEnter: marketingGuard
    },

    // Charity
    // view active
    {
      path: "/lps/charity",
      name: "charity-view",
      component: () =>
        import("./views/contents/loyalty/Admin/Charity/View.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/charity/add",
      name: "charity-add",
      component: () => import("./views/contents/loyalty/Admin/Charity/Add.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/charity/report/:id",
      name: "charity-report",
      component: () =>
        import("./views/contents/loyalty/Admin/Charity/Report.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/charity/payment",
      name: "charity-payment",
      component: () =>
        import("./views/contents/loyalty/Admin/Charity/Payout.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/charity/redeem-list/:id",
      name: "charity-redeem-list",
      component: () =>
        import("./views/contents/loyalty/Admin/Charity/Redeemed_list.vue"),
      beforeEnter: marketingGuard
    },

    // marketing Dashboard
    {
      path: "/lps/dashboard",
      name: "dashboard-marketing",
      component: () => import("./views/contents/loyalty/Admin/Dashboard.vue"),
      beforeEnter: marketingGuard
    },

    // Charity Report
    {
      path: "/report/charity/view_report/:id/:month/:year",
      name: "charity-report-view",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Charity/View.vue")
    },

    // {
    //   path: "/report/charity/view/:id/:month/:year",
    //   name: "charity-report-details",
    //   component: () =>
    //     import("./views/contents/loyalty/Admin/Report/Charity/Report.vue")
    // },
    {
      path: "/report/charity/view/:id",
      name: "charity-report-details",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Charity/Report.vue"),
      beforeEnter: marketingGuard
    },
    {
      path: "/report/charity/donations/:id",
      name: "charity-donations",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Charity/Donation.vue"),
      beforeEnter: marketingGuard
    },

    // view inactive
    // {
    //   path: "/charity/inactive",
    //   name: "charity-view",
    //   props: { active: false },
    //   component: () =>
    //     import("./views/contents/loyalty/Admin/Charity/View.vue")
    // },

    // details
    {
      path: "/lps/charity/details/:id",
      name: "charity-details",
      component: () =>
        import("./views/contents/loyalty/Admin/Charity/View_details.vue"),
      beforeEnter: marketingGuard
    },

    // Setting
    {
      path: "/lps/point",
      name: "TBM-view",
      component: () =>
        import("./views/contents/loyalty/Admin/Setting/TBMPoint/View.vue"),
      beforeEnter: settingGuard
    },

    {
      path: "/lps/point/details",
      name: "TBM-details",
      component: () =>
        import("./views/contents/loyalty/Admin/Setting/TBMPoint/Details.vue"),
      beforeEnter: settingGuard
    },

    {
      path: "/lps/charity-point",
      name: "charityPoint-view",
      component: () =>
        import("./views/contents/loyalty/Admin/Setting/CharityPoint/View.vue"),
      beforeEnter: settingGuard
    },

    {
      path: "/lps/charity-point/edit",
      name: "charityPoint-edit",
      component: () =>
        import("./views/contents/loyalty/Admin/Setting/CharityPoint/Edit.vue"),
      beforeEnter: settingGuard
    },

    {
      path: "/marketing/survey-referral",
      name: "surveyReferral-view",
      component: () =>
        import(
          "./views/contents/loyalty/Admin/Setting/SurveyReferral/View.vue"
        ),
      beforeEnter: settingGuard
    },

    {
      path: "/marketing/survey-referral/details/:id",
      name: "surveyReferral-edit",
      component: () =>
        import(
          "./views/contents/loyalty/Admin/Setting/SurveyReferral/Details.vue"
        ),
      beforeEnter: settingGuard
    },

    {
      path: "/lps/report/view/:type",
      name: "report-view",
      component: () => import("./views/contents/loyalty/Admin/Report/View.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/report/view/:id/:month/:year",
      name: "report-details",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Details.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/report/update/:id",
      name: "report-update",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Update.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/report/pay/:id",
      name: "pay-update",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Update_pay.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/summary-report",
      name: "summary-report",
      component: () =>
        import("./views/contents/loyalty/Admin/Summary/Report.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/report-summary",
      name: "report-summary",
      component: () =>
        import("./views/contents/loyalty/Admin/Summary/Reports.vue")
    },

    {
      path: "/lps/report/expired-points",
      name: "report-expired-points",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Points/expired.vue")
    },

    {
      path: "/lps/voucher/product",
      name: "voucher-product",
      component: () =>
        import("./views/contents/loyalty/Admin/Voucher/Product.vue"),
      beforeEnter: settingGuard
    },
    {
      path: "/lps/voucher/product/:id",
      name: "voucher-product-id",
      component: () =>
        import("./views/contents/loyalty/Admin/Voucher/View.vue"),
      beforeEnter: settingGuard
    },
    {
      path: "/lps/loyalty-cards",
      name: "loyalty_cards",
      component: () =>
        import("./views/contents/loyalty/Marketing/LoyaltyCards.vue"),
      beforeEnter: marketingGuard
    },
    {
      path: "/lps/points-earned",
      name: "points_earned",
      component: () =>
        import("./views/contents/loyalty/Marketing/PointsEarned.vue"),
      beforeEnter: marketingGuard
    },
    {
      path: "/lps/points-spent",
      name: "points_spent",
      component: () =>
        import("./views/contents/loyalty/Marketing/PointsSpent.vue"),
      beforeEnter: marketingGuard
    },

    // My Activity
    {
      path: "/marketing/my-activity",
      name: "my_activity",
      component: () => import("./views/contents/my-activity/index.vue"),
      beforeEnter: marketingGuard
    },
    {
      path: "/marketing/my-activity/new",
      name: "add_activity",
      component: () => import("./views/contents/my-activity/add.vue"),
      beforeEnter: marketingGuard
    },
    {
      path: "/marketing/my-activity/details/:id",
      name: "activity_detail",
      component: () => import("./views/contents/my-activity/detail.vue"),
      beforeEnter: marketingGuard
    },

    /**
     * ROLE VENDORS
     */
    // Transactions
    {
      path: "/transaction",
      name: "vendor-transactions",
      component: () =>
        import("./views/contents/loyalty/Vendor/Transaction/View.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/transaction/summary/:id",
      name: "vendor-transactions-summary",
      component: () =>
        import("./views/contents/loyalty/Vendor/Transaction/Summary.vue"),
      beforeEnter: vendorGuard
    },

    // Redeem
    {
      path: "/redeem",
      name: "vendor-redeems",
      component: () =>
        import("./views/contents/loyalty/Vendor/Redeem/RedeemView.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/redeem/summary/:id",
      name: "vendor-redeem-summary",
      component: () =>
        import("./views/contents/loyalty/Vendor/Redeem/RedeemSummary.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/redeem/report",
      name: "vendor-redeem-report",
      component: () =>
        import("./views/contents/loyalty/Vendor/Redeem/RedeemDemographic.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/redeem/voucher/report",
      name: "vendor-redeem-voucher-report",
      component: () =>
        import("./views/contents/loyalty/Vendor/Redeem/VoucherDemographic.vue")
    },
    {
      path: "/refund",
      name: "vendor-refunds",
      component: () =>
        import("./views/contents/loyalty/Vendor/Redeem/RefundView.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/refund/summary/:id",
      name: "vendor-refund-summary",
      component: () =>
        import("./views/contents/loyalty/Vendor/Redeem/RefundSummary.vue"),
      beforeEnter: vendorGuard
    },

    // Products and Services
    {
      path: "/products-services",
      name: "vendor-products",
      component: () =>
        import("./views/contents/loyalty/Vendor/ProductAndService/View.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/products-services/add",
      name: "vendor-products-add",
      component: () =>
        import("./views/contents/loyalty/Vendor/ProductAndService/Add.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/products-services/update/:id",
      name: "vendor-products-update",
      component: () =>
        import("./views/contents/loyalty/Vendor/ProductAndService/Update.vue"),
      beforeEnter: vendorGuard
    },

    // Payouts
    {
      path: "/payout",
      name: "vendor-payout",
      component: () =>
        import("./views/contents/loyalty/Vendor/Payout/View.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/payout/view/:id/:month/:year",
      name: "vendor-payout-view",
      component: () =>
        import("./views/contents/loyalty/Vendor/Payout/Update.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/payout/invoice/:id/:month",
      name: "vendor-payout-invoice",
      component: () => import("./views/contents/loyalty/Vendor/Payout/Add.vue"),
      beforeEnter: vendorGuard
    },

    // Company details
    {
      path: "/banner",
      name: "vendor-banner",
      component: () =>
        import("./views/contents/loyalty/Vendor/Company/View.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/qrcode",
      name: "vendor-qrcode",
      component: () =>
        import("./views/contents/loyalty/Vendor/Company/QrCode.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/banner/add/:id",
      name: "vendor-banner-add",
      component: () =>
        import("./views/contents/loyalty/Vendor/Company/Add.vue"),
      beforeEnter: vendorGuard
    },
    {
      path: "/banner/update/:id/:type",
      name: "vendor-banner-update",
      component: () =>
        import("./views/contents/loyalty/Vendor/Company/Update.vue"),
      beforeEnter: vendorGuard
    },

    // User Balance
    {
      path: "/lps/user-balance",
      name: "user-balance",
      component: () => import("./views/contents/loyalty/Admin/User/index.vue")
    },
    {
      path: "/lps/user-balance/detail/:user_id",
      name: "user-balance",
      component: () => import("./views/contents/loyalty/Admin/User/detail.vue")
    },

    // Exchange rate history
    {
      path: "/exchange-rate-history",
      name: "exchange-rate-history",
      component: () =>
        import("./views/contents/loyalty/Admin/History/exchangeRate.vue")
    },

    //Affiliate - Referral code
    {
      path: "/lps/affiliate",
      name: "affiliates",
      component: () =>
        import("./views/contents/loyalty/ReferralCode/Affiliate/Index.vue")
    },

    {
      path: "/lps/affiliate/payment",
      name: "affiliate-payment",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Affiliate/Payout.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/affiliate/referral/:id",
      name: "affiliate-details",
      component: () =>
        import("./views/contents/loyalty/ReferralCode/Affiliate/Details.vue")
    },

    {
      path: "/lps/report/view/affiliate",
      name: "affiliate-report",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Affiliate/Report.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/affiliate/report/used/:id",
      name: "affiliate-refferal-used",
      component: () =>
        import("./views/contents/loyalty/Admin/Report/Affiliate/Used.vue"),
      beforeEnter: marketingGuard
    },

    {
      path: "/lps/affiliate/add",
      name: "affiliate-add",
      component: () =>
        import("./views/contents/loyalty/ReferralCode/Affiliate/Add.vue")
    },
    {
      path: "/lps/affiliate/edit/:id",
      name: "affiliate-edit",
      component: () =>
        import("./views/contents/loyalty/ReferralCode/Affiliate/Edit.vue")
    },
    {
      path: "/lps/affiliate/referral-code/add/:id",
      name: "referral-code-add",
      component: () =>
        import("./views/contents/loyalty/ReferralCode/Referral/Add.vue")
    },
    {
      path: "/lps/affiliate/referral-code/edit/:id",
      name: "referral-code-edit",
      component: () =>
        import("./views/contents/loyalty/ReferralCode/Referral/Edit.vue")
    },

    // Marketing Campaign
    {
      path: "/campaign",
      name: "campaign",
      component: () => import("./views/contents/campaign/View.vue")
    },

    // Deleted Account
    {
      path: "/deleted-account",
      name: "deleted-account",
      component: () => import("./views/contents/DeletedAccount.vue")
    },

    // View / Add Award Points
    {
      path: "/lps/award-points",
      name: "award-points",
      component: () => import("./views/contents/loyalty/Admin/Award/index.vue")
    },

    {
      path: "/lps/add-award-points",
      name: "add-award-points",
      component: () => import("./views/contents/loyalty/Admin/Award/add.vue")
    },

    {
      path: "/lps/award-points-details/:id",
      name: "award-points-details",
      component: () => import("./views/contents/loyalty/Admin/Award/detail.vue")
    },

    {
      path: "/lps/award-event-details/:event_id",
      name: "award-event-details",
      component: () =>
        import("./views/contents/loyalty/Admin/Award/multipleDetail.vue")
    },

    // end

    /**
     * Cash Winner
     */
    {
      path: "/lps/cash-winner",
      name: "cash-winner",
      component: () => import("./views/contents/cashwinner/Index.vue")
    },

    {
      path: "/lps/cash-winner/add",
      name: "add-event-winner",
      component: () => import("./views/contents/cashwinner/Add.vue")
    },

    {
      path: "/lps/cash-winner/:event_id",
      name: "view-event-winner",
      component: () => import("./views/contents/cashwinner/View.vue")
    },

    // Otp page
    {
      path: "/auth_otp",
      name: "auth_otp",
      component: () => import("./views/contents/Otp_page.vue")
    },

    {
      path: "/variables",
      name: "variables-page",
      component: () => import("./views/contents/variables/Index.vue")
    },

    /**
     * Webinar / Archive
     */
    {
      path: "/marketing/webinar",
      name: "webinar-page",
      component: () => import("./views/contents/webinar")
    },

    {
      path: "/marketing/archive/add",
      name: "add-archive",
      component: () => import("./views/contents/webinar/addArchive.vue")
    },

    {
      path: "/marketing/archive/edit/:id",
      name: "edit-archive",
      component: () => import("./views/contents/webinar/editArchive.vue")
    },

    /**
     * Newsletter
     */
    {
      path: "/marketing/newsletter",
      name: "newsletter-page",
      component: () => import("./views/contents/newsletter")
    },

    {
      path: "/marketing/newsletter/add",
      name: "add-newsletter",
      component: () => import("./views/contents/newsletter/add.vue")
    },

    {
      path: "/marketing/newsletter/edit/:id",
      name: "edit-newsletter",
      component: () => import("./views/contents/newsletter/edit.vue")
    },

    /**
     * Gifts
     */
    {
      path: "/gift",
      name: "gift-page",
      component: () => import("./views/contents/gifts")
    },
    {
      path: "/gift/add",
      name: "add-gift-page",
      component: () => import("./views/contents/gifts/add")
    },
    {
      path: "/gift/edit/:id",
      name: "edit-gift-page",
      component: () => import("./views/contents/gifts/edit")
    },

    {
      path: "/marketing/approved-gifts",
      name: "approved-gifts",
      component: () => import("./views/contents/approved-gifts")
    },
    {
      path: "/marketing/gift/edit/:id",
      name: "edit-approved-gift-page",
      component: () => import("./views/contents/approved-gifts/edit")
    },
    {
      path: "/marketing/gift/report",
      name: "gift-report-page",
      component: () => import("./views/contents/approved-gifts/report")
    },
    {
      path: "/marketing/gift/report/details/:id",
      name: "gift-report-details-page",
      component: () =>
        import("./views/contents/approved-gifts/report/details.vue")
    },

    {
      path: "/marketing/tier-downgrade",
      name: "tier-downgrade",
      component: () => import("./views/contents/approved-gifts/tier-downgrade")
    },

    // Mass Notification
    {
      path: "/marketing/mass-notification",
      name: "mass-notification-index",
      component: () => import("./views/contents/mass-notification")
    },
    {
      path: "/marketing/mass-notification/add",
      name: "mass-notification-add",
      component: () => import("./views/contents/mass-notification/add")
    },
    {
      path: "/marketing/mass-notification/:id",
      name: "mass-notification-view",
      component: () => import("./views/contents/mass-notification/view")
    },

    // Fire Content Listing
    {
      path: "/tba/content-listings",
      name: "content-listing-index",
      component: () => import("./views/contents/content-listing/index.vue"),
    },
    {
      path: "/tba/content/:id/details",
      name: "content-listing-details",
      component: () => import("./views/contents/content-listing/view.vue"),
    },
  ]
});
